// src/KeycloakProvider.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { getKeycloakInstance } from "./keycloak";

const KeycloakContext = createContext();

export const KeycloakProvider = ({ children }) => {
    const [keycloak, setKeycloak] = useState(null);
    const [authenticated, setAuthenticated] = useState(false);
    const [profilePic, setProfilePic] = useState(null)

    useEffect(() => {
        const kc = getKeycloakInstance();
        kc.init({
            onLoad: "check-sso",
            silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        })
            .then(async (auth) => {
                setAuthenticated(auth);
                setKeycloak(kc);

                // Get Microsoft Access Token
                const microsoftToken = kc.token;

                console.log(kc)

                // Function to fetch the profile picture from Microsoft Graph API
                const fetchMicrosoftProfilePic = async (accessToken) => {
                    try {
                        // console.log(accessToken)
                        const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
                            headers: {
                                Authorization: `Bearer ${accessToken}`
                            }
                        });

                        if (response.ok) {
                            console.log('pic returned ok')
                            return URL.createObjectURL(await response.blob());
                        } else {
                            console.error('Failed to fetch profile picture');
                            return null;
                        }
                    } catch (error) {
                        console.error('Error fetching profile picture:', error);
                        return null;
                    }
                };

                // Fetch Profile Picture from Microsoft Graph API
                const photoUrl = await fetchMicrosoftProfilePic(microsoftToken);
                setProfilePic(photoUrl);
            })
            .catch((error) => {
                console.error("Keycloak initialization failed", error);
            });
    }, []);

    return (
        <KeycloakContext.Provider value={{ keycloak, authenticated, profilePic }}>
            {children}
        </KeycloakContext.Provider>
    );
};

export const useKeycloak = () => useContext(KeycloakContext);
